import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

//import enTranslations from '../locales/en.json'
import esTranslations from '../locales/es.json'

const customTFunction = (key: string, options?: any): string => {
    const translation = i18n.t(key, options)

    if (typeof translation === 'string') {
        return translation
    }

    // If no translation found or translation is not a string, convert the key to a readable format
    return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim()
}

i18n.use(initReactI18next).init({
    resources: {
        //en: { translation: enTranslations },
        es: { translation: esTranslations }
    },
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
        escapeValue: false
    },
    saveMissing: true
})

export { customTFunction as t }

// eslint-disable-next-line import/no-default-export
export default i18n
